module.exports = __webpack_public_path__ + "static/img/ac-ddz.2f95fbf4.jpg";